export default defineAppConfig({
  title: 'Bali Bikes Island',
  theme: {
    dark: false
  }
})
